export const greet = (currentHour) => {
  switch (currentHour) {
    case currentHour < 12:
      return 'Good Morning';
    case currentHour >= 17 && currentHour <= 24:
      return 'Good Evening';
    default:
      return 'Good Afternoon';
  }
};

// let msg;

// if (currentHour < 12) msg = 'Good Morning';
// else if (currentHour >= 12 && currentHour <= 17) msg = 'Good Afternoon';
// else if (currentHour >= 17 && currentHour <= 24) msg = 'Good Evening';
// console.log('ygubybi', currentHour);
// console.log(greet(14), 'kkkkk');

export const dueStyles = {
  justify: 'space-between',
  bg: '#EFE2FF',
  p: '5px 10px',
  color: '#4A1977',
  borderRadius: '5px',
  fontWeight: 500,
};
// justify='space-between'
// bg='bgColorLight'
// p='5px 10px'
// mt='10px'
// color='primary'
// borderRadius='5px'

export const monthsAheadStyles = {
  // bg: '#EFE2FF',
  // justify: 'space-between',
  // align: 'center',
  // px: '20px',
  // py: '3px',
  // borderRadius: '5px',
  // fontWeight: 'bold',

  bg: 'primaryLight',
  justify: 'space-between',
  align: 'center',
  px: '20px',
  py: '5px',
  borderRadius: '5px',
};

export const amountToPayInputStyles = {
  bg: 'gray.100',
  type: 'number',
  fontWeight: 'bold',
  placeholder: '30000',
  color: '#614385',
  fontSize: '1rem',
};
